import { getFile, objectToQueryParams } from '@si/utils';
import { useMutation } from '@tanstack/react-query';
import { useCallback } from 'react';

interface DownloadParams {
  projectId: string;
  filepath: string;
  filename: string;
}

export function useDownloadOldReport() {
  const { mutate, error, isPending, isSuccess, reset } = useMutation<void, Error, DownloadParams>({
    mutationFn: ({ projectId, filepath, filename }: DownloadParams) =>
      getFile({
        url: `/projects/${projectId}/reports/download-old-report${objectToQueryParams({
          filepath,
          filename,
        })}`,
      }),
  });

  const downloadReport = useCallback((params: DownloadParams) => mutate(params), [mutate]);

  return {
    downloadReport,
    error,
    isPending,
    isSuccess,
    reset,
  };
}
